import { useCallback } from "preact/hooks";
import { useEventListener } from "./useEventListener";

const useAutoUnlockAudio = (id: string) => {
    const unlockAudio = useCallback(() => {
        const video = document.getElementById(id) as HTMLVideoElement;
        const audio = document.getElementById(id) as HTMLAudioElement;
        if (video) {
            try {
                video.muted = false;
                document.removeEventListener("pointerdown", unlockAudio);
            } catch (error) {
                console.error("Failed to unlock audio. Retrying on next interaction...", error);
            }
        }
        if (audio) {
            try {
                audio.pause();
                audio.muted = false;
                document.removeEventListener("pointerdown", unlockAudio);
                } catch (error) {
                console.error("Failed to unlock audio. Retrying on next interaction...", error);
            }
        }
    }, [id]);

    useEventListener("pointerdown", unlockAudio, document);
};

export default useAutoUnlockAudio;
